import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Field,
  reduxForm,
} from 'redux-form';
import {
  Card, CardBody, Col, Row, Badge,
} from 'reactstrap';
import renderSelectField from '../../../shared/components/form/Select';

import DataTable from '../../../shared/components/DataTable';
import TooltipItem from '../../../shared/components/TooltipItem';

class SubjectForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    handleDeleteCorrelativa: PropTypes.func.isRequired,
    handleAddCorrelativa: PropTypes.func.isRequired,
    onFilterChanges: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    nombre: PropTypes.string,
    codigo: PropTypes.string,
    notas: PropTypes.string,
    semestre: PropTypes.number,
    malla: PropTypes.string,
    correlativas: PropTypes.arrayOf(PropTypes.shape({})),
    materiasDisponibles: PropTypes.arrayOf(PropTypes.shape({})),
  }

  static defaultProps = {
    submitting: false,
    nombre: '',
    codigo: '',
    notas: '',
    semestre: 0,
    malla: '',
    correlativas: [],
    materiasDisponibles: [],
  }

  constructor(props) {
    super(props);

    this.deleteCorrelativa = this.deleteCorrelativa.bind(this);

    this.state = {
      page: 1,
      pageSize: 100,
      totalItemsCount: 0,
    };

    this.columns = [
      {
        key: 'id',
        name: '#',
        search: false,
        width: '60px',
      },
      {
        key: 'materiaCodigo',
        name: 'Código',
        search: false,
        width: '100px',
        format: row => (
          <Badge color="primary">{row.materiaCodigo}</Badge>
        ),
      },
      {
        key: 'materiaNombre',
        name: 'Materia correlativa',
        search: false,
      },
      {
        key: 'semestre',
        name: 'Semestre',
        search: false,
        format: row => (
          <Badge color="primary">{`${row.semestre}º`}</Badge>
        ),
      },
      { key: 'actions', name: 'Acción', width: '85px' },
    ];

    this.correlativaActions = [
      {
        key: 'delete',
        icon: <span className="fa fa-trash" title="Eliminar correlativa" />,
        callback: (correlativa) => {
          this.deleteCorrelativa(correlativa);
        },
      },
    ];
  }

  deleteCorrelativa = (correlativa) => {
    if (correlativa) {
      const { handleDeleteCorrelativa } = this.props;
      handleDeleteCorrelativa(correlativa);
    }
  };

  getGridActions = (key) => {
    const actions = { actions: this.correlativaActions };
    return actions[key];
  }

  handleAddCorrelativaAndClear = () => {
    const { handleAddCorrelativa, change } = this.props;
    handleAddCorrelativa(() => {
      change('materiaCorrelativaSeleccionada', null);
    });
  }

  render() {
    const {
      handleSubmit,
      onBack,
      submitting,
      nombre,
      codigo,
      notas,
      semestre,
      malla,
      correlativas,
      materiasDisponibles,
      onFilterChanges,
    } = this.props;

    const { page, pageSize, totalItemsCount } = this.state;

    return (
      <Form className="form" onSubmit={handleSubmit}>
        <Card>
          <CardBody>
            <Row>
              <Col md={12}>
                <h4 className="bold-text">
                  {codigo ? <Badge color="secondary">{codigo}</Badge> : null}
                  {' '}{nombre}
                </h4>
                {(malla || semestre) && (
                  <p className="page-subhead subhead">
                    {malla && <span><strong>Malla:</strong> {malla}{' '}</span>}
                    {semestre && <span><strong>Semestre:</strong> {semestre}</span>}
                  </p>
                )}
                {notas && (
                  <p className="page-subhead subhead">{notas}</p>
                )}
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <h5 className="bold-text mt-3">Agregar materia malla correlativa</h5>
              </Col>
            </Row>

            <Row className="align-items-end">
              <Col md={4}>
                <div className="form__form-group">
                  <span className="form__form-group-label">Materia malla correlativa</span>
                  <div className="form__form-group-field">
                    <Field
                      name="materiaCorrelativaSeleccionada"
                      component={renderSelectField}
                      options={materiasDisponibles}
                      placeholder="Seleccione materia malla correlativa..."
                      onChange={v => onFilterChanges('materiaCorrelativaSeleccionada', v)}
                    />
                  </div>
                </div>
              </Col>
              <Col md={2}>
                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={submitting}
                  onClick={this.handleAddCorrelativaAndClear}
                  id="btn-add-correlativa"
                >
                  <span className="fa fa-plus" /> Agregar
                </button>
                <TooltipItem
                  target="btn-add-correlativa"
                  text="Agregar correlativa a la materia malla actual"
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <h5 className="bold-text mt-3">Correlativas asignadas</h5>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                {correlativas.length === 0
                  ? (
                    <p className="page-subhead subhead">
                      No hay correlativas asignadas para esta materia.
                    </p>
                  )
                  : (
                    <DataTable
                      title="Correlativas"
                      columns={this.columns}
                      items={correlativas}
                      page={page}
                      pageSize={pageSize}
                      totalItemsCount={totalItemsCount || correlativas.length}
                      getGridActions={key => this.getGridActions(key)}
                      enableReinitialize
                    />
                  )
                }
              </Col>
            </Row>

            <Row>
              <Col md={12} className="mt-3">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={onBack}
                >
                  <span className="fa fa-arrow-left" /> Volver
                </button>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Form>
    );
  }
}

const ReduxSubjectForm = reduxForm({
  form: 'subject_correlativas_form',
  enableReinitialize: true,
})(SubjectForm);

export default ReduxSubjectForm;
